import {AUTH_FAIL, AUTH_LOGOUT, AUTH_START, AUTH_SUCCESS, SET_AUTH_REDIRECT_PATH} from "./actionTypes";
import axios from '../axiosApi';
import jwt from "jwt-decode";


export const authStart = () => {
    return {
        type: AUTH_START
    }
}


export const authSuccess = (authData) => {
    const  user = jwt(authData.accessToken);
//    console.log("jwt", user);

    return {
        type: AUTH_SUCCESS,
        id: authData.accessToken,
        userId: user.id,
        error: null,
        name: user.name || user.username,
        firstName: user.firstName,
        email: user.email,
        defaultTenant: user.defaultTenant,
        expiresIn: user.exp,
        lastName: user.lastName,
        username: user.username,
        permissions: user.permissions,
        frontEndPermissions: user.frontEndPermissions

    }
}

export const authSetMock = () => {

//    console.log("jwt", user);

    return {
        type: AUTH_SUCCESS,
        id: 'mock',
        userId: 99999,
        error: null,
        name: `Lukatec Feira`,
        firstName: 'lukatec',
        email: 'lukatec@lukatec.com.br',
        defaultTenant: 0,
        expiresIn: '9999999999999',
        lastName: 'demo',
        username: 'lukatec.offline',
        permissions: [],
        frontEndPermissions: [2,1000,1100,1101,1102,1103,1104,1200,1300,1400,1401,1402,1500,1600,1700,1800,1900,1901,1902,1903,2000,2100,2101,2102,2103,2200,2104,2300,2301 ]

    }
}

export const authFail = (error) => {
    return {
        type: AUTH_FAIL,
        error : error
    }
}


export const logout = () => {
    return {
        type: AUTH_LOGOUT,
        id: null
    };
}

export const checkAuthTimeout = (expirationTime) => {
    return dispatch => {
        setTimeout(() => {
           // console.log('TIMEOUT DISPATCHED!!')
            dispatch(logout());

        }, expirationTime)
    }
}

export const authLogout = () => {
    return dispatch => {
            // console.log('TIMEOUT DISPATCHED!!')
            if (localStorage.getItem('accessToken')) {localStorage.clear();}
            dispatch(logout());
    }
}


export  const auth = (username, password) => {
    return dispatch => {

        if ( (username === "demo.offline") && (password === "lukatec") ) {
            dispatch(authSetMock())
            return;
        }

        dispatch(authStart());
        let userdata = {
            username: username,
            password: password
        };
        let url = `/auth/login`;
       console.log("auth url", url, userdata);
        axios.post(url, userdata)
            .then(responseJSON => {
                    console.log('auth url response', responseJSON);
                    if (responseJSON && !responseJSON.data.accessToken) {
                        dispatch(authFail(responseJSON.message));
                    } else {

                        axios.defaults.headers.common['Authorization'] = "Bearer " + responseJSON.data.accessToken;
                        dispatch(authSuccess(responseJSON.data));
                        //TODO: avaliar necessidade de configurar um timeout da sessao
                        // dispatch(checkAuthTimeout(responseJSON.ttl));
                    }
                },
                error => {
                    console.log('Error while running Login api: ', error);
                    dispatch(authFail(error));
                })

    }
}

export const setAuthRedirectPath = (path) => {
    return {
        type: SET_AUTH_REDIRECT_PATH,
        path: path
    };
};
